import { httpClient } from 'core/net/http';

// The anonymous client still sends the auth cookie but attaches no response interceptor. The
// authorised client's interceptor redirects on any 401, which would send an already-expired logout
// through backend authentication instead of the static login page.
export const logout = async () => {
  return await httpClient.useInternalApi.anonymous().post('security/logout', {});
};
